/* Common Imports */
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: "3rem 8rem 3rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "0rem 1rem 0rem 1rem",
    },
  },
  megaContainer: {
    width: "100%",
    background: "#A8616C",
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      margin: "2.5rem 0rem 2.5rem 0rem",
    },
  },
  heading: {
    width: "100%",
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 1.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },

  illustrationSizer: {
    // objectFit: "contain",
    // width: "1500px",
    // height: "650px",
    [theme.breakpoints.up("xl")]: {
      width: "2450px",
      height: "680px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "auto",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto",
    },
  },
  text: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },

  legendcontent: {
    background: "#A8616C",
    width: "100%",
    padding: "1.5rem",
    marginTop: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    borderRadius: "1.5rem",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  legendColumn: {
    flex: 1,
  },
  legendItem: {
    fontSize: "1rem",
    color: "#FFFFFF",
    padding: "0.5rem",
    borderRadius: "0.25rem",
    // display: "flex",
    gap: "0.5rem",
    "& span": {
      color: "inherit",
    },
  },
  legendItemmobile: {
    fontSize: "1rem",
    color: "#FFFFFF",
    borderRadius: "0.25rem",
    gap: "0.5rem",
    "& span": {
      color: "#212121",
    },
  },
  dialogContent: {
    position: "relative",
    padding: "16px !important",
    overflow: "hidden",
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  zoomableContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    cursor: "grab",
    "&:active": {
      cursor: "grabbing",
    },
  },
  zoomableImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transformOrigin: "0 0",
    transition: "transform 0.1s ease-out",
  },
  masterplancontentmobile: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    background: "#EEDFE2",
    padding: "1.5rem",
    marginTop: "1rem",
    borderRadius: "0.5rem",
    width: "100%",
  },
  previewLegend: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  seeMoreText: {
    color: "#A8616C",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "0.5rem",
    textAlign: "center",
  },
  drawerPaper: {
    backgroundColor: "#EEDFE2",
    padding: "0rem 2rem 2rem 2rem",
    minHeight: "50vh",
    maxHeight: "80vh",
    overflowY: "auto",
    borderTopLeftRadius: "1rem",
    borderTopRightRadius: "1rem",
  },
  drawerContent: {
    height: "100%",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
  },
  legendcontentmobile: {
    width: "100%",
  },
  drawerLegendItem: {
    fontSize: "1rem",
    color: "#212121",
    padding: "0.5rem",
    borderRadius: "0.25rem",
    display: "flex",
    gap: "0.5rem",
  },
  drawercontentdata: {
    fontSize: "1rem",
    color: "#212121",
    padding: "0.5rem",
  },
  legendItemsContainer: {
    paddingBottom: "2rem",
    overflowY: "auto",
  },
  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "1rem 0",
    marginBottom: "1.5rem",
    position: "sticky",
    top: 0,
    backgroundColor: "#EEDFE2",
    zIndex: 1,
  },
  drawerHeading: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "1.25rem",
  },
  closeButton: {
    color: "#212121",
    padding: "8px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
}));

const ZoomableImage = ({ src, alt }) => {
  const classes = useStyles();
  const [transform, setTransform] = React.useState({
    scale: 1,
    translateX: 0,
    translateY: 0,
  });
  const [isDragging, setIsDragging] = React.useState(false);
  const [dragStart, setDragStart] = React.useState({ x: 0, y: 0 });
  const containerRef = React.useRef(null);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY * -0.002;
    const newScale = Math.min(Math.max(transform.scale + delta, 1), 4);

    if (newScale !== transform.scale) {
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const scaleChange = newScale - transform.scale;
      const newTranslateX = transform.translateX - x * scaleChange;
      const newTranslateY = transform.translateY - y * scaleChange;

      setTransform({
        scale: newScale,
        translateX: newTranslateX,
        translateY: newTranslateY,
      });
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX - transform.translateX,
      y: e.clientY - transform.translateY,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging && transform.scale > 1) {
      const newTranslateX = e.clientX - dragStart.x;
      const newTranslateY = e.clientY - dragStart.y;

      setTransform({
        ...transform,
        translateX: newTranslateX,
        translateY: newTranslateY,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleDoubleClick = () => {
    setTransform({
      scale: 1,
      translateX: 0,
      translateY: 0,
    });
  };

  return (
    <div
      ref={containerRef}
      className={classes.zoomableContainer}
      onWheel={handleWheel}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onDoubleClick={handleDoubleClick}
    >
      <img
        src={src}
        alt={alt}
        className={classes.zoomableImage}
        style={{
          transform: `translate(${transform.translateX}px, ${transform.translateY}px) scale(${transform.scale})`,
        }}
        draggable={false}
        loading="lazy"
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

const MasterPlan = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <Typography
          variant="h1"
          component="h1"
          className={classes.heading}
        >
          Master plan
        </Typography>

        <div className={classes.sectionContainer}>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
          >
            <DialogContent>
              <ZoomableImage
                src="/images/icons/heavie/halcyon_masterplan.png"
                alt={AppConfig.imageAltText}
              />
            </DialogContent>
          </Dialog>

          <div className={classes.legendcontent}>
            <Typography
              variant="h6"
              className={classes.heading}
              style={{ margin: 0, color: "#ffffff" }} // Reset margin since we're using gap
            >
              Legend
            </Typography>
            <div style={{ display: "flex", width: "100%", gap: "2rem" }}>
              <div className={classes.legendColumn}>
                {[
                  "Entrance gate",
                  "Security cabin",
                  "Silver Oak Avenue",
                  "Rain Tree Garden",
                  "Visitor parking",
                  "Herb/medicinal garden",
                  "Vehicular corridor",
                  "Walking corridor",
                  "Drop-off zone",
                  "Welcome Atrium",
                  "Lounge",
                  "Indoor games",
                  "Multipurpose hall",
                  "Toilets",
                  "Gym / yoga",
                  "Business center",
                ].map((item, index) => (
                  <div
                    key={item}
                    className={classes.legendItem}
                  >
                    <span>{index + 1}. </span>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className={classes.legendColumn}>
                {[
                  "Sculpture garden",
                  "Backdrop wall",
                  "Elders garden",
                  "Kids play garden",
                  "Sitting court below pergola",
                  "Mini maze with pollinator plants",
                  "Basket ball dribble court",
                  "Spike ball",
                  "Services",
                  "Akhada",
                  "BBQ",
                  "Pickle ball court",
                  "Poolside with cabanas",
                  "Open studio deck",
                  "Gated pet park",
                  "Exit Basement Ramp",
                ].map((item, index) => (
                  <div
                    key={item}
                    className={classes.legendItem}
                  >
                    <span>{index + 17}. </span>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <img
            src="/images/icons/heavie/halcyon_masterplan.png"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
            onClick={handleOpen} // Open dialog on click
            style={{ cursor: "pointer" }} // Add pointer cursor on hover
          />
          <div className={classes.masterplancontentmobile}>
            <div className={classes.legendcontentmobile}>
              <Typography
                variant="h6"
                className={classes.heading}
                style={{ margin: "0rem 0rem 0.5rem 0rem" }}
              >
                Legend
              </Typography>

              <div className={classes.previewLegend}>
                {["Entrance gate", "Security cabin", "Silver Oak Avenue"].map((item, index) => (
                  <div
                    key={item}
                    className={classes.legendItemmobile}
                  >
                    <span>{index + 1}. </span>
                    <span>{item}</span>
                  </div>
                ))}
                <Typography
                  className={classes.seeMoreText}
                  onClick={() => setDrawerOpen(true)}
                >
                  See more
                </Typography>
              </div>

              <SwipeableDrawer
                anchor="bottom"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                onOpen={() => setDrawerOpen(true)}
                classes={{
                  paper: classes.drawerPaper,
                }}
                PaperProps={{
                  elevation: 0,
                  style: { overscrollBehavior: "contain" }, // Prevent parent scroll while drawer is open
                }}
                disableSwipeToOpen={false}
                SwipeAreaProps={{
                  style: { height: 0 }, // Prevent swipe area from taking space when closed
                }}
              >
                <div className={classes.drawerContent}>
                  <div className={classes.drawerHeader}>
                    <Typography
                      variant="h6"
                      className={classes.drawerHeading}
                    >
                      Legend
                    </Typography>
                    <IconButton
                      onClick={() => setDrawerOpen(false)}
                      className={classes.closeButton}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <div className={classes.legendItemsContainer}>
                    {[
                      "Entrance gate",
                      "Security cabin",
                      "Silver Oak Avenue",
                      "Rain Tree Garden",
                      "Visitor parking",
                      "Herb/medicinal garden",
                      "Vehicular corridor",
                      "Walking corridor",
                      "Drop-off zone",
                      "Welcome Atrium",
                      "Lounge",
                      "Indoor games",
                      "Multipurpose hall",
                      "Toilets",
                      "Gym / yoga",
                      "Business center",
                      "Sculpture garden",
                      "Backdrop wall",
                      "Elders garden",
                      "Kids play garden",
                      "Sitting court below pergola",
                      "Mini maze with pollinator plants",
                      "Basket ball dribble court",
                      "Spike ball",
                      "Services",
                      "Akhada",
                      "BBQ",
                      "Pickle ball court",
                      "Poolside with cabanas",
                      "Open studio deck",
                      "Gated pet park",
                      "Business center",
                    ].map((item, index) => (
                      <div
                        key={item}
                        className={classes.drawercontentdata}
                      >
                        <span>{index + 1}. </span>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </SwipeableDrawer>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default MasterPlan;
